import { render, staticRenderFns } from "./LiveData.vue?vue&type=template&id=61412de1&scoped=true&"
import script from "./LiveData.vue?vue&type=script&lang=js&"
export * from "./LiveData.vue?vue&type=script&lang=js&"
import style0 from "./LiveData.vue?vue&type=style&index=0&id=61412de1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61412de1",
  null
  
)

export default component.exports